import React, { useState, useEffect, useContext, useMemo } from "react";
import { Container, Row, Col } from 'react-bootstrap'
import URLstateContext from "../../../../provider/CommonContext";
import {
    GetPostMethodData,
    DecryptAESdata,
} from "../../../../provider/ServiceProvider";
import NodatafoundImg from "../../../../images/no-data.png";
import { format, parseISO } from 'date-fns'
import Pagination from "../../../CommonUI/Pagination/Pagination";
import { Vortex } from 'react-loader-spinner'
import animation from '../../../../images/jm-animation.gif';



function InnerPressRelease() {
    const [data, setData] = useState("");
    const { BaseURL } = useContext(URLstateContext);
    const [artical, Setarticle] = useState("press release");
    const [currentPage, setCurrentPage] = useState(1);
    const [loadingshow, setloadingshow] = useState(false);
    const [SearchText, setSearchText] = useState('');
    useEffect(() => {
        setloadingshow(true);
        GetPostMethodData(BaseURL + "GetPressRelease", {
            IVarticletype: artical,
            IVsearch: SearchText
        }).then((data) => {
            if (data.data != null && data.data.length > 0) {
                setData(DecryptAESdata(data.data));
                setloadingshow(false);
                //console.log(DecryptAESdata(data.data))
            } else {
                setData(null)
                setloadingshow(false);
            }
        });
    }, [BaseURL, artical, SearchText]);

    let PageSize = 5;
    const currentTableData = useMemo(() => {
        if (data != null) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data, PageSize]);
    const handleInputChange = (event) => {
        let Blogdata = event.target.value;
        setSearchText(Blogdata);
    }
    return (
        <>
            <section className="press-release-sc">
                <Container>
                    <Row>
                        <Col>
                            <div className="search-div">
                                <div className="form-group-container mb-0">
                                    <div className="form-group search-input mb-0">
                                        <input type="text" className='ourFund-product' name="SearchBlogs" onChange={handleInputChange} id="SearchBlogs" placeholder="Search..." />
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>

                <Container>
                    <Row>
                        <Col sm={12} className="padding-left-0">
                            
                        {(currentTableData === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''}
                            {currentTableData &&
                                currentTableData.map(({ articledate, articletype, heading, fileext, linklocation }) => (
                                    <div className="ads-container">
                                        {/* <div className="date-box">
                                            {articledate.split("/")[0]}
                                        </div> */}
                                        <div className="notice-box">
                                            <div className="date">
                                               {/* {format(parse(articledate, 'M/d/yyyy h:mm:ss a', new Date()), 'dd MMMM, yyyy')} */}
                                               {/* {articledate ? format(parseISO(articledate), 'dd MMMM, yyyy') : ''} */}
                                                {/* (Date.split('T')[0]) */}
                                                {/* {console.log(typeof(articledate))} */}
                                                {(articledate != null) ? (format(parseISO(articledate), 'do MMM, yyyy')) : ''}
                                                {/* {(articledate).split(" ")[0]} */}
                                            </div>
                                            <p>
                                                <a href={linklocation} target="_blank"> <span>{articletype}</span> - {heading}</a>
                                            </p>
                                        </div>
                                    </div>
                                ))}
                            {loadingshow ? <div className="textcentervertex">
                                <img src={animation} alt="Loading" />
                                <div className="model_popup">Please Wait...</div>
                            </div> : ""
                            }
                            {data != null ? (
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={data.length != null ? data.length : 0}
                                    pageSize={PageSize}
                                    showTitle = {false}
                                    onPageChange={(page) => setCurrentPage(page)}
                                />
                            ) : ''}
                        </Col>
                    </Row>
                </Container>

            </section>

        </>
    )
}

export default InnerPressRelease